import { Pipe, PipeTransform } from '@angular/core';
import moment from 'moment';
import { constants } from '@constants/constants';

@Pipe({ standalone: false, name: 'date' })
export class DatePipe implements PipeTransform {
  constructor() {}

  transform(date: Date): string {
    if (!date) {
      return '';
    }

    return moment(date).format(constants.dateInputFormat);
  }
}
